// @ts-nocheck
import { map } from "./map"
import { ordered_object } from "./ordered_object"

/**
 * Maps iterable to object with custom key and value functions.
 *
 * @param keyf - Function to generate keys from (value, key/index)
 * @param valuef - Function to generate values from (value, key/index)
 * @param iterable - Array, object, or primitive to map
 * @returns Object with mapped keys and values
 *
 * @example
 * ```ts
 * import { object_map } from "@pdfking/rfunc"
 *
 * object_map(v => v, v => v + 2, [1, 2, 3]) // { 1: 3, 2: 4, 3: 5 }
 * object_map((v, i) => i + 1, (v, i) => v + 2, [4, 5, 6]) // { 1: 6, 2: 7, 3: 8 }
 * ```
 */
export const object_map = (keyf, valuef, iterable) =>
  ordered_object(
    map((value, key) => [keyf(value, key), valuef(value, key)], iterable)
  )
